import { render } from "./WalletsItem.vue?vue&type=template&id=ca6b0274"
import script from "./WalletsItem.vue?vue&type=script&lang=js"
export * from "./WalletsItem.vue?vue&type=script&lang=js"

import "./WalletsItem.vue?vue&type=style&index=0&id=ca6b0274&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__